{
  "title": "Sharing your location allows you to speed up the check-in process",
  "body": "We're sorry, but we can't complete your check-in without access to your location. Please grant location access to continue. We only use your location for warehouse check-in purposes and do not store or share your location information with third parties.",
  "shareLocation": "Share my location"
}
